/**
 * Dashboard Constants
 * 
 * Configuration constants for Dashboard component
 */

export const DASHBOARD_CONFIG = {
  /**
   * API timeout in milliseconds
   * Reduced from 10s to 8s for better UX
   */
  API_TIMEOUT_MS: 8000,

  /**
   * Retry configuration
   */
  RETRY_ATTEMPTS: 2,
  RETRY_DELAY_MS: 1000,
} as const;
